var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('div',[_c('side-navigation'),_c('v-main',[_c('div',{staticClass:"max-width"},[_vm._t("default")],2)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }